export default __webpack_public_path__ + "static/19-25ae1de627bcdc097dbf5e942fd52e69.webp";